import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { medicalImagingTranslationKeys } from '../../../../translations';
import { VisitFormController } from '../../visitForm.types';

import { AddMedicalImagingLink } from './AddMedicalImagingLink';

type MedicalImagingTableEmptyStatePlaceholderProps = {
   readonly patientId: number;
   readonly visitId: number;
   readonly controller: VisitFormController;
};

export const MedicalImagingTableEmptyStatePlaceholder = (
   props: MedicalImagingTableEmptyStatePlaceholderProps
): JSX.Element => {
   return (
      <EmptyStatePlaceholder
         heading={medicalImagingTranslationKeys.emptyStatePlaceholder.heading}
         testId={'noMedicalImaging'}
         subheading={medicalImagingTranslationKeys.emptyStatePlaceholder.subheading}
         bottomElement={
            <AddMedicalImagingLink patientId={props.patientId} visitId={props.visitId} controller={props.controller} />
         }
      />
   );
};
